<template>
<page-outline :title="$t('mandate.create_payment_schedule')">
  <template slot="pageContent">
    <div>
        <b-row class="min-w-100 justify-content-start align-items-center">
          <b-col cols="12" class="d-flex justify-content-start mt-3 mb-5">
            <back-button class="btnFilter_2 mr-2 btn-back" :returnUrl="returnUrl"></back-button>
          </b-col>
        </b-row>
        <b-row class="justify-content-start">
        <spinner v-if="activateSpinner"></spinner>
        <div v-else class="min-w-100">

          <div v-if="isReport" class="body">
              <!-- RESULTS -->
              <div>
                <div class="font-weight-bold">
                  <i class="icon fa fa-file" style="margin-right:15px;"/>
                  <span>{{ $t('filter.nameFile') + ' : ' }}</span>
                  <span>{{ fileName? fileName : 'test.csv' }}</span>
                </div>
                <div class="my-2 py-2 line-success">
                  <i class="icon fa fa-check" style="margin-right:15px;"/>
                  <span>{{ results.ACCP }} {{$t("company.fileLineAproove")}}</span>
                </div>
                <div class="my-2 py-2 line-update">
                  <i class="fa-solid fa-envelope-dot" style="margin-right:15px;"/>
                  <span>{{ results.UPDT }} {{$t("company.fileLineUpdated")}}</span>
                </div>
                <div class="my-2 py-2 line-warning">
                  <i class="icon fa fa-pencil" style="margin-right:15px;"/>
                  <span>{{ results.EXST }} {{$t("company.fileLineAlreadyExist")}}</span>
                </div>
                <div class="my-2 py-2 line-error">
                  <i class="icon fa fa-times" style="margin-right:15px;"/>
                  <span>{{ results.RFSL }} {{$t("company.fileLineReject")}}</span>
                </div>
              </div>
          </div>
          <div class="d-flex mt-3 justify-content-end">
            <b-col id="btnFakeUpload" class="inline-flex" v-if="!isReport">
              <label class="fake-import-button" for="image_uploads">{{ fileName ? $t("company.fileReplace") : $t('company.fileChoose')}}</label>
              <!--<label class="font-weight-bold fileSelected">{{$t("company.fileSelect")}}</label>-->
              <label v-if="!fileName" for="image_uploads">{{$t("company.fileNone")}}</label>
              <label v-else for="image_uploads">{{ fileName }}</label>
              <input type="file" :key="hiddenButtonKey"
              id="image_uploads"
              ref="file"
              accept=".csv" multiple="" class="opacity-0"
              @change="handleFileUpload()"/>
            </b-col>
              <!-- DOWNLOAD REPORT -->
            <div class="download" v-if="isReport">
              <div class="btn btn-primary">
                <a @click="downloadReport">
                  <i class="icon fa fa-download"/><span class="download-report-text">{{$t("company.fileDownloadReport")}}</span>
                </a>
              </div>
            </div>
            <div class="mb-5 col-lg-2 col-xl-2 col-4">
              <button
                type="button"
                class="btn btn-secondary"
                @click="cancel">
                {{ isReport ? 'OK' : $t("company.fileCancel") }}
              </button>
            </div>
            <div class="mb-5 col-lg-2 col-xl-2 col-4" v-if="!isReport">
              <button
                type="button"
                class="btn btn-primary"
                :disabled="fileContent === '' || fileName === '' || showLoader"
                @click="send">
                {{$t("company.fileSend")}}
              </button>
            </div>
          </div>
        </div>
        </b-row>
      </div>
      </template>
      </page-outline>
</template>

<script>
import moment from 'moment'
//import Pagination from '@/components/common/pagination.vue'
import Spinner from '@/components/common/spinner.vue'
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage,reloadPage} from '@/helpers/routing'
import PageOutline from '@/components/common/PageOutline.vue'
import {downloadFile} from '@/helpers/download'
import {verifyMandatoryValues, checkErrorFlag} from '@/helpers/validator'
import BackButton from '@/components/common/backButton.vue'



export default {
  name: 'CompaniesImport',
  components: {
    BackButton,
    //'cm-pagination': Pagination,
    'spinner': Spinner,
    'page-outline': PageOutline
  },
  props: {
    additionalClass: {
      type: String,
      default: ''
    },
    direction: {
      default: '2',
      type: String
    },
    redirection: { /*props redirection activé si = 1. Défini si redirection lorsque nous avons qu'une seule entrerprise DRO 15/01/2024*/
      default: '0',
      type: String
    }
  },
  computed: {
    listTitle () {
      return this.$t('Webheader.company')
    },
    canUserImportCompagny() {
      return this.$engine.rights.rightIs('company_import', true) || this.$engine.rights.rightIs('company_import', true)
    }
  },
  data () {
    return {
      activateSpinner: false,
      active: '',
      identifier: '',
      filterBy: '',
      name: '',
      CompaniesList: [],
      idCompany: '',
      hiddenButtonKey: false,
      mode: 1,
      noMore: false,
      pageCounter: 0,
      paginationObject: {},
      randomId: Math.random().toString(36).substr(2, 10),
      requestsNumber: '',
      scrollFlag: true,
      sortDirection: 'DESC',
      sortField: 'dateAction',
      displayFilter: false,
      hasDefaultFilter: false,
      timer: '',
      fileName: '',
      fileNameError: false,
      file: undefined,
      importName: '',
      importNameError: false,
      isReport: false,
      reportData: '',
      fileContent: '',
      results: {},
      showLoader: false
    }
  },
  created () {
    let that = this
    that.returnUrl = '/payment-schedules/unit'
  },
  mounted () {

    this.$$('.infinite-scroll-preloader').remove()
    this.$bus.emit('set-small-panel')
    //let defaultFilter = this.$engine.company.getDefaultFilter()
    //this.setDefaultFilter(defaultFilter)
  },
  beforeDestroy () {
    let that = this
    that.$engine.company.cleanFilterCondition()
  },
  methods: {
    cancel () {
      this.fileName = false
      this.isReport = false
      this.hiddenButtonKey = !this.hiddenButtonKey
    },
    send () {
      let that = this
      let flagsList = { 'fileName': true }
      let mandatoryValues = ['fileName']
      flagsList = verifyMandatoryValues(mandatoryValues, flagsList, this)
      if (checkErrorFlag(flagsList)) {
        return
      }
      this.showLoader = true
      let params = {
        Data: this.fileContent,
        CodeLanguage: this.$i18n.locale.toUpperCase(),
        FileName: this.fileName
      }
      this.$engine.paymentSchedule.addPaymentScheduleBulk(params)
        // .then(resp => {
        //   this.results.ACCP = resp.data.LineAccepted
        //   this.results.EXST = resp.data.LineExists
        //   this.results.UPDT = resp.data.LineUpdated
        //   this.results.RFSL = resp.data.LineRejected
        //
        //   this.isReport = true
        //   that.showLoader = false
        //   this.reportData = resp.data.CheckingReport ? resp.data.CheckingReport : ''
        //   // this.$bus.$emit('sm-notif', {title: resp.statusText, encoded: true})
        //   this.$f7.alert('', this.$t('annuaire.file_imported'))
        // })
        // .catch(err => {
        //   let title = that.$t('error')
        //   let description = that.$t('errorHappend')
        //   if (err && err.response && err.response.statusText && err.response.data && err.response.data.errorDescription) {
        //     title = err.response.statusText
        //     description = err.response.data.errorDescription
        //   }
        //   // that.$bus.$emit('sm-notif', {title: title, description: description, error: true, encoded: true})
        //   this.$f7.alert(description, title)
        //   that.showLoader = false
        //   if (err && err.response && err.response.status >= 410 && err.response.status <= 422) {
        //     this.$emit('close')
        //     that.$bus.$emit('logout')
        //   }
        // })
        .then(resp => {
          that.$f7.modal({
            title: that.$t('mandate.file_imported'),
            buttons: [
              {
                text: 'OK',
                onClick: function () {
                  return
                }
              }
            ]
          })
          loadPage(that, {url: '/payment-schedules/bulk'})
        })
        .catch(err => {
          let title = that.$t('error')
          let description = that.$t('errorHappend')
          if (err && err.response && err.response.statusText && err.response.data && err.response.data.errorDescription) {
            title = err.response.statusText
            description = err.response.data.errorDescription
          }
          // that.$bus.$emit('sm-notif', {title: title, description: description, error: true, encoded: true})
          this.$f7.alert(description, title)
          that.showLoader = false
          if (err && err.response && err.response.status >= 410 && err.response.status <= 422) {
            this.$emit('close')
            that.$bus.$emit('logout')
          }
        })
    },
    downloadReport () {
      if (this.reportData) {
        downloadFile(moment().format('DDMMYYYYhhmmss') + '_rapport.csv', this.reportData)
      } else {
        // this.$bus.$emit('sm-notif', {title: that.$t('error'), description: that.$t('noFile'), error: true})
        this.$f7.alert(that.$t('noFile'), that.$t('error'))
      }
    },
    handleFileUpload () {
      let that = this
      if (this.$refs.file && this.$refs.file.files && this.$refs.file.files.length) {
        this.file = this.$refs.file.files[0]
        this.fileName = this.file.name
        let fd = new FileReader()
        fd.onload = (event) => {
          let fileData = event.target.result
          if (fileData) {
            try {
              that.fileContent = btoa(fileData)
              if (that.fileContent.length > 5800000) {
                this.$refs.file.value = ''
                that.fileContent = ''
                // that.$bus.$emit('sm-notif', {title: that.$t('error'), description: that.$t('toobigFile'), error: true})
                this.$f7.alert(that.$t('toobigFile'), that.$t('error'))
                return
              }
            } catch (e) {
              let fd2 = new FileReader()
              fd2.onload = (event) => {
                let fileData = event.target.result
                if (fileData) {
                  try {
                    that.fileContent = btoa(fileData)
                    if (that.fileContent.length > 5800000) {
                      that.$refs.file.value = ''
                      that.fileContent = ''
                      that.$bus.$emit('sm-notif', {title: 'Erreur', description: 'Fichier d\'import trop volumineux.', error: true})
                      this.$f7.alert('Fichier d\'import trop volumineux.', that.$t('error'))
                      return
                    }
                  } catch (e2) {
                    that.$refs.file.value = ''
                    that.fileContent = ''
                    that.$bus.$emit('sm-notif', {title: 'Erreur', description: 'Erreur dans le fichier d\'import.', error: true})
                    this.$f7.alert('Erreur dans le fichier d\'import.', that.$t('error'))
                  }
                }
              }
              fd2.readAsText(this.file, 'windows-1252')
            }
          }
        }
        fd.readAsText(this.file)
      }
    }
  }
}
</script>
<style scoped>
.readable-filename {
  background-color: #e6e6e6;
}

.fake-import-button{
  cursor:pointer;
  background-color: #f5f3f3;
  border: 2px solid var(--borderButtonColorBlue);
  color: var(--actionTextColorBlue);
  min-width: 250px;
  max-width: -webkit-fill-available;
  padding:5px;
  margin-right:5px;
  min-height:30px;
  border-radius: 5px;
}

.fileSelected{
  width:auto;
}

.line-success {
  background-color: #dff0d8;
  color: black;
  font-weight: bold;
  padding-left:4px;
}

.line-update {
  background-color: #add2dc;
  color: black;
  font-weight: bold;
  padding-left:4px;
}

.line-warning {
  background-color: #fcf8e3;
  color: black;
  font-weight: bold;
  padding-left:4px;
}

.line-error {
  background-color: #ff9191;
  color: black;
  font-weight: bold;
  padding-left:4px;
}

.download-report-text {
  color: #fff;
  font-weight: bold;
  cursor: pointer;
  min-height:30px;
  Line-height:1;
  vertical-align: middle;
  padding:2px;
}

.download{
  min-height:30px;
  Line-height:1;
  vertical-align: middle;
  width:250px;
}
.download .btn.btn-primary {
    background: var(--actionButtonColorBlue);
    border: 2px solid var(--borderButtonColorBlue);
    color: var(--actionTextColorWhite);
    width: inherit;
    max-width: -webkit-fill-available;
    Line-height:1;
    vertical-align: middle;
    padding-top: 8px !important;
}

.download .btn a{
  min-height:30px;
  Line-height:1;
  vertical-align: middle;
  width:inherit;

}

.download-report-text {
  color: #fff;
  font-weight: bold;
  cursor: pointer;
  min-height:30px;
  Line-height:1;
  vertical-align: middle;
  padding:2px;
}
</style>
